export default "__VITE_ASSET__BX5xNgg___"